import axios from 'axios';

export default axios.create({
    baseURL: 'https://dindin-back.cyclic.app',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json'
    }
})